export const FORMAT_JSON = 'json';
export const FORMAT_XML = 'xml';

export const LINK_TYPE_JSON = 'application/json+oembed';
export const LINK_TYPE_XML = 'text/xml+oembed';

export const TYPE_VIDEO = 'video';
export const TYPE_PHOTO = 'photo';

export const TARGET_SHARE_PAGE_EMBED_PARAM = 'target-share-page-embed';
